import React from 'react';
import { motion } from 'framer-motion';

const backdropVariants = {
	hidden: { opacity: 0 },
	visible: { opacity: 1 },
};

const modalVariants = {
	hidden: { scale: 0, opacity: 0 },
	visible: { scale: 1, opacity: 1 },
};

const Modal = ({ image, imageAlt, show, onClose }) => {
	if (!show) return null;

	return (
		<motion.div className="modal-backdrop" variants={backdropVariants} initial="hidden" animate="visible" exit="hidden" onClick={onClose}>
			<motion.div className="modal" variants={modalVariants}>
				<img src={image} alt={imageAlt} />
			</motion.div>
		</motion.div>
	);
};

export default Modal;
